<template>
  <div class="login">
    <div class="modal" :class="{'is-active':showEdit}">
      <div class="modal-background" @click="showEdit = false"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Edit Account Info</p>
          <button class="delete" aria-label="close" @click="showEdit = false"></button>
        </header>
        <section class="modal-card-body">
          <div id="not-padded" class="content">
            <form @submit.prevent="onEditAccount">
              <div class="field">
                <label class="label">Username</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.userName}"
                    type="text"
                    v-model="userInfo.userName"
                    placeholder
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.userName,'is-hidden':!errors.userName}"
                  v-text="errors.userName"
                ></p>
              </div>
              <div class="field">
                <label class="label">Password</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.password}"
                    type="text"
                    v-model="userInfo.password"
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.password,'is-hidden':!errors.password}"
                  v-text="errors.password"
                ></p>
              </div>
              <div class="field">
                <label class="label">First Name</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.firstName}"
                    type="text"
                    v-model="userInfo.firstName"
                    placeholder
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.firstName,'is-hidden':!errors.firstName}"
                  v-text="errors.firstName"
                ></p>
              </div>
              <div class="field">
                <label class="label">Second Name</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.secondName}"
                    type="text"
                    placeholder
                    v-model="userInfo.secondName"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.secondName,'is-hidden':!errors.secondName}"
                  v-text="errors.secondName"
                ></p>
              </div>
              <div class="field">
                <label class="label">Phone Number</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.phone}"
                    type="tel"
                    v-model="userInfo.phone"
                    placeholder
                    required
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.phone,'is-hidden':!errors.phone}"
                  v-text="errors.phone"
                ></p>
              </div>
              <div class="field">
                <label class="label">Email</label>
                <div class="control">
                  <input
                    class="input"
                    :class="{'is-danger':errors.email}"
                    type="email"
                    placeholder
                    v-model="userInfo.email"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fas fa-check"></i>
                  </span>
                </div>
                <p
                  class="help"
                  :class="{'is-danger':errors.email,'is-hidden':!errors.email}"
                  v-text="errors.email"
                ></p>
              </div>
              <div class="field">
                <label class="label">Location</label>
                <select v-model="userInfo.location">
                  <option v-for="location in locations"
                          :key="location._id"
                          :value="location._id">
                    {{ location.apartment }}
                  </option>
                </select>
              </div>
            </form>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button
            class="button is-success"
            :class="{'is-loading':isLoading}"
            @click="onEditAccount()"
          >Save</button>
          <button class="button" @click="showEdit = false">Cancel</button>
        </footer>
      </div>
    </div>
    <div class="login-card">
      <div class="content">
        <p class="status has-text-centered">HelpLine: <span class="status-notification">0746 627 355</span></p>
        <p class="status has-text-centered">
          Status:
          <span class="status-notification is-success" v-if="routerAuth">Online</span>
          <span class="status-notification is-danger" v-if="!routerAuth">Offline</span>
        </p>
        <p class="status has-text-centered">
          IP:
          <span class="status-notification">{{session.ip}}</span>
        </p>
        <div class="level">
          <div class="level-item has-text-centered">
            <div>
              <p class="title is-5">Time Remaining</p>
              <p class="subtitle">{{session.timeleft || 0}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="title is-5">Data Remaining</p>
              <p class="subtitle">{{session.remainbytesin || 0}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="title is-5">Router Name</p>
              <p class="subtitle">{{session.router}}</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <p class="title is-5">Balance</p>
              <p class="subtitle">
                kes
                <span>{{user.acctBalance}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="field is-grouped is-grouped-centered">
          <p class="control">
            <a class="button is-primary is-small" @click="populate()">Edit Account</a>
          </p>
          <p class="control">
            <a
              class="button is-primary is-small"
              @click="onRenewPlan()"
              :class="{'is-loading':renewing}"
            >Renew Plan From Balance</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import alertify from "alertifyjs";
import axios from "axios";

export default {
  data: function() {
    return {
      showEdit: false,
      showRenew: false,
      userInfo: {
        userName: "",
        password: "",
        firstName: "",
        secondName: "",
        email: "",
        phone: "",
        location: ""
      },
      errors: {
        userName: "",
        password: "",
        firstName: "",
        secondName: "",
        email: "",
        phone: ""
      },
      isLoading: false
    };
  },
  created: function() {
    this.getLocations()
    alertify.set("notifier", "position", "top-center");
    alertify.set("notifier", "delay", 2);
  },
  methods: {
    ...mapActions(["getLocations"]),
    validate() {
      var self = this;
      var result = true;
      for (const key in self.userInfo) {
        switch (key) {
          case "userName":
            if (/^[A-Za-z0-9_-]{3,16}$/.test(self.userInfo[key])) {
              self.errors[key] = "";
            } else {
              result = false;
              self.errors[key] =
                "Username length between 3 to 16 characters without spaces or special characters";
            }
            break;
          case "firstName":
            if (self.userInfo[key]) {
              if (/^[a-zA-Z]{3,16}$/.test(self.userInfo[key])) {
                self.errors[key] = "";
              } else {
                result = false;
                self.errors[key] =
                  "Field should not have spaces or special characters";
              }
            }
            break;
          case "secondName":
            if (self.userInfo[key]) {
              if (/^[a-zA-Z]{3,16}$/.test(self.userInfo[key])) {
                self.errors[key] = "";
              } else {
                result = false;
                self.errors[key] =
                  "Field should not have spaces or special characters";
              }
            }
            break;
          case "password":
            break;
          case "email":
            if (self.userInfo[key]) {
              if (
                /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/.test(
                  self.userInfo[key]
                )
              ) {
                self.errors[key] = "";
              } else {
                result = false;
                self.errors[key] = "Email address not valid";
              }
            }
            break;
          case "phone":
            if (/^([+]254|254|0)(7)[0-9]{8}/.test(self.userInfo[key])) {
              self.errors[key] = "";
            } else {
              result = false;
              self.errors[key] = "Phone Number not valid";
            }
            break;
        }
      }
      return result;
    },
    populate() {
      this.showEdit = true;
      this.userInfo.userName = this.user["userName"];
      this.userInfo.password = this.user["password"];
      this.userInfo.firstName = this.user["firstName"];
      this.userInfo.secondName = this.user["secondName"];
      this.userInfo.email = this.user["email"];
      this.userInfo.phone = this.user["phone"];
      this.userInfo.location = this.user["location"]
    },
    onEditAccount() {
      if (this.validate()) {
        this.isLoading = true;
        var self = this;
        axios
          .post(
            "/api/client/edit",
            self.userInfo
          )
          .then(function(response) {
            self.isLoading = false;
            var body = response.data;
            if (body.success) {
              console.log(body.message);
              alertify.success("Info Updated");
            } else if (body.validationErrors) {
              body.errors.forEach(error => {
                self.errors[error.path] = error.error;
              });
            }
          })
          .catch(function(error) {
            self.isLoading = false;
            console.log(error);
            alertify.error("Error Occured Editing Account");
          });
      }
    },
    onRenewPlan() {
      //var self = this;
      this.$store.dispatch("renewPlan");
    }
  },
  computed: {
    ...mapState([
      "session",
      "user",
      "serverAuth",
      "routerAuth",
      "renewing",
      "locations"
    ])
  }
};
</script>

<style scoped>
.status-notification.is-success {
  color: green;
}

.status-notification.is-danger {
  color: red;
}
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  /*background: #f7f7f7;*/
}
.login-card {
  margin-top: auto;
  margin-bottom: auto;
  background: #fff;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
}
@media only screen and (max-width: 768px) {
  .login-card {
    width: 100%;
  }
  button {
    margin: 1.3em;
  }
}

@media only screen and (min-width: 768px) {
  .level-item {
    margin: 0.7em;
  }
}
.content {
  padding: 3rem 2.5rem 5rem;
}
#not-padded {
  padding: 1rem 1.5rem 1rem;
}
.card {
  background: #fff;
  width: 24rem;
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11);
  padding: 3rem 2.5rem 5rem;
}
</style>
